import { useMutation, useQueryClient } from '@tanstack/react-query'
import { GuiasApi } from '@/services/api-routes'
import type { CancelamentoManualPayload, CancelamentoPayload } from '@/types/guia'
import { guiasKeys } from '@/http/queryKeys'
import { notifyErrorFor, notifySuccess } from '@/utility/notify'

export const useCancelarGuiaMutation = (mensagemSucesso: string, onSuccess?: () => void) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: CancelamentoPayload) => GuiasApi.cancelar(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: guiasKeys.all })
      notifySuccess(mensagemSucesso)
      onSuccess?.()
    },
    onError: (error) => notifyErrorFor('cancelar a autorização', error),
  })
}

export const useCancelarGuiaManualMutation = (onSuccess?: () => void) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: CancelamentoManualPayload) => GuiasApi.cancelarManual(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: guiasKeys.all })
      notifySuccess('Guia cancelada manualmente no IntegraDoor com sucesso!')
      onSuccess?.()
    },
    onError: (error) => notifyErrorFor('cancelar a autorização manualmente', error),
  })
}
